export const formatAddress = (address) => {
    try {
        if(typeof address !== 'string') {
            return address;
        }
        return `${address.slice(0, 6)}...${address.slice(-6)}`
    } catch (ex) {
        return address;
    }
}